module.exports = __webpack_public_path__ + "img/Loong2.21752a6e.png";